// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3bpls","alert":"SettungsInbox_alert__2Oc9_"};